
<template>
	<div class="header_dv">
		<div class="header_top_dv flex-one">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item v-for="(item , index ) in $store.state.routePath" :key="index"  >{{item.title}}</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="kf_cover_dv flex-row">
				<!-- <el-avatar
					:size="18"
					fit="cover"
					:src="$store.state.adminInfo.au_avatar_url?$store.state.adminInfo.au_avatar_url:''"
				></el-avatar> -->
				<p>{{getUser.au_nickname}}（{{getUser.au_username}}）</p>
			</div>
		</div>
		<div class="header_bottom_dv">
			<ul class="flex-row">
				<transition-group name="el-zoom-in-center"  class="flex-row">
					<li class="flex" v-for="(tag ,index) in $store.state.tags" :key="tag.title" @click.stop="goHtmlFun(tag,index)" 
						:style="{background:tag.bagColor}"
						@mouseover="mouseOverCloseFun(tag,index)" 
						@mouseleave="mouseLeaveCloseFun(tag,index)">
						<div v-show="tag.isCourrentWeb"></div>
						<p>{{tag.title}}</p>
						<span v-show="tag.closeIcon" @click.stop="handleClose(tag)" >x</span>
					</li>
				</transition-group>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	props: {
		headTitle: {
			type: String,
			default: "您好！超级管理员！",
		},
	},
	components: {
		//声明组件名称
	},
	data() {
		return {
			isOnClick :false
		};
	},
	created() {
	},
	computed: {
		//获取vuex里的 数据
		...mapGetters(["getUser"]),
	},
	methods: {
		/**
		 * 鼠标移入
		 * 
		 */
		mouseOverCloseFun(data,index){
			console.log(data)
			if(data.title == "后台首页")  return false
			if(this.isOnClick == true) return false
			//将数据更新到vuex
			this.$store.commit('editTagsCloseIcon',{'data':data,'index':index,'status':true})
		},
		/**
		 * 鼠标移出
		 * 
		 */
		mouseLeaveCloseFun(data,index){
			if(this.isOnClick == true) return false
			//将数据更新到vuex--
			this.$store.commit('editTagsCloseIcon',{'data':data,'index':index,'status':false})
		} ,
		//关闭标签
		handleClose(tag) {
			this.$store.commit('closeTags',tag)
			//关闭后 取数组最后一个作为高亮展示
			let tags = this.$store.getters.getTags
			if(tags.length == 0){
				//所有标签已经关闭，跳转首页
			}else{
				let endtag = tags.slice(-1);
				this.goHtmlFun(endtag[0],null)
			}
		},
		//点击tag 跳转页面
		goHtmlFun(tag,index){
			let _this = this
			this.isOnClick = true
			setTimeout(()=>{
				_this.isOnClick = false
			},1000)
			this.$store.commit('editTagsIsCourrentWeb',tag)
			this.$router.push({ path:tag.path });
		},
		
	},
};
</script>

<style lang="scss" scoped>
.header_dv .el-tag{
	margin: 17px 10px 0 0px;
}
</style>

<style lang="scss" scoped>
.header_dv{
	width: 100%;
	position:fixed;
	top:0;
	left:0;
	background-color: #f7f7f7;
	box-shadow: 10px 2px 10px rgba(0, 0, 0, 0.3980392156862745);
}
.header_top_dv {
	background-color: #f7f7f7;
	padding-left: 220px;
	box-sizing: border-box;
	width: 100%;
	height: 30px;
	.kf_cover_dv {
		margin-right:20px;
		border-radius: 50%;
		position: relative;
		img {
			width: 100%;
			height: 100%;
			border-radius: 50%;
		}
	}
	p {
		margin-left: 10px;
		font-family: "思源黑体 CN";
		font-weight: 400;
		font-style: normal;
		color: #555555;
		line-height: 30px;
		font-size: 12px;
	}
}
.header_bottom_dv {
	min-width: 1200px;
	background-color: #f7f7f7;
	padding-left: 220px;
	box-sizing: border-box;
	width: 100%;
	height: 50px;
	cursor: pointer;
	ul{
		min-width: 1200px;
		li{
			margin-top:17px;
			position:relative;
			min-width:40px;
			line-height:32px;
			padding:0 10px;
			background-color:#CCC;
			margin-right:10px;
			border-radius: 5px;
			color:#fff;
			font-size: 12px;
			div{
				width:10px;
				height:10px;
				border-radius: 50%;
				background-color:#4f7da4;
				margin-top:12px;
				margin-right:5px;
			}
			span{
				line-height:13px;
				text-align: center;
				font-size: 17px;
				display:block;
				width:16px;
				height:16px;
				border-radius: 50%;
				position:absolute;
				top: -5px;
				right: -2px;
				background-color:#e80707;
			}
		}
	}
  .left {
    font-size: 18px;
    text-align: left;
    font-family: "思源黑体 CN";
    font-weight: 400;
    font-style: normal;
    color: #4f7da4;
    line-height: 50px;
    .icon-zuo {
      margin-right: 5px;
    }
  }
  .right {
    width: 300px;
    margin-right: 20px;
    li {
      font-family: "思源黑体 CN";
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      color: #7f7f7f;
      line-height: 50px;
      cursor: pointer;
      &:hover {
        color: #4f7da4;
      }
    }
    .dataActiveColor {
      color: #4f7da4;
    }
  }

  .history_right {
    width: 370px;
    li {
      display: flex;
      &:hover {
        border-bottom: 2px solid #4f7da4;
      }
      span {
        color: #4f7da4;
      }
      p {
        margin-left: 10px;
        color: #4f7da4;
      }
    }
  }
  .map_right {
    width: 100px;
  }
}
.classify {
  ::v-deep .el-tabs__nav {
    height: 50px;
  }
  ::v-deep .el-tabs__item {
    height: 50px;
    line-height: 50px;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    background-color: transparent;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #4f7da4;
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #4f7da4;
  }
  ::v-deep .el-tabs__item:hover {
    color: #4f7da4;
  }
}
.home {
  //   cursor: pointer;
}
</style>